import { matchRestRequest } from '../utils'

export const mockGetShiftTutorials = {
  shouldMock: (request) =>
    matchRestRequest(
      request,
      '/company/graphql_dispatch/shift_tutorials_001f782e',
      'POST'
    ),
  getResponse: async () => {
    return Promise.resolve({
      data: {
        company: {
          shiftsDetail: [
            {
              tutorials: [],
              location: {},
              position: {},
            },
          ],
        },
      },
    })
  },
}
